"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var labeledContent_exports = {};
__export(labeledContent_exports, {
  labeledContentProps: () => labeledContentProps
});
module.exports = __toCommonJS(labeledContent_exports);
function labeledContentProps(props) {
  var { label, value, systemImage, hasChildren } = props;
  if (typeof label !== "string" || !label) throw new Error("Swift.LabeledContent label must be a non-empty string");
  if (value !== void 0 && typeof value !== "string") throw new Error("Swift.LabeledContent value must be a string");
  if (systemImage !== void 0 && typeof systemImage !== "string") throw new Error("Swift.LabeledContent systemImage must be a string");
  if (value !== void 0 && hasChildren) throw new Error("Swift.LabeledContent takes either a value or children");
  if (value === void 0 && !hasChildren) throw new Error("Swift.LabeledContent needs a value or children");
  return {
    label,
    value: value !== null && value !== void 0 ? value : "",
    systemImage: systemImage !== null && systemImage !== void 0 ? systemImage : ""
  };
}
//# sourceMappingURL=labeledContent.js.map
